import React, { Component } from "react"
import { Query, Mutation } from "react-apollo"
import { Redirect } from "react-router-dom"
import RestrictedMessage from "../../components/RestrictedMessage"
import Message from "../../components/Message"
import restrictedAccess from "../../graphql/restrictedAccess.graphql"
import requestUpgrade from "../../graphql/requestUpgrade.graphql"

import "./restricted.scss"

class Restricted extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSuccessMessage: false,
    }
  }

  messages = () => {
    switch (this.props.data.productPreview.proprietaryDataset.toUpperCase()) {
      case "TSIS":
      case "ETS":
      case "PCAS":
        return {
          title: this.props.data.productPreview.name,
          subtitle: "You do not have access to this report.",
          message:
            "Request to upgrade to our ETR Master Plan and get access to all our data reports. Get in touch with our sales team now!",
        }
      case "VENN":
        return {
          title: this.props.data.productPreview.name,
          subtitle: "You do not have access to this report.",
          message:
            "Speak with a sales rep about adding VENN to your subscription?",
          purchaseSubscriptionMessage:
            "Subscribe to VENN and get access to all our VENN reports. Check out the plan details now!",
          purchaseSubscription: true,
        }
      default:
        return {
          title: "ETR Data",
          subtitle: "",
          message: "",
          expiredTrial: {
            subtitle: "Your Free Trial period has expired.",
            message:
              "Keep getting access to all our data by simply subscribing to our ETR Plus plan. Check out the plan details now!",
          },
        }
    }
  }

  sendEmail = async () => {
    let response = await this.props.sendEmail(this.props.data.productPreview.id)
    this.setState({ showSuccessMessage: true })
  }

  populateMessage = () => {
    const productURL = `/marketplace/${this.props.data.productPreview.slug[0]}`
    return (
      <RestrictedMessage
        data={this.messages()}
        productUrl={productURL}
        sendEmail={this.sendEmail}
      />
    )
  }

  render() {
    if (!this.props.data.viewer.isUserAuthenticated) {
      return <Redirect to={"/404"} />
    }

    return (
      <div
        className="restricted"
        style={{
          backgroundImage:
            "url(https://s3.amazonaws.com/prod-etr/uploads/images/etr-numbers-bg.png)",
        }}
      >
        <div className="restricted__col">
          {this.state.showSuccessMessage ? (
            <Message
              title="Email Sent"
              message="Someone from our sales team will get in touch with you within 24 hours."
              type="success"
            />
          ) : (
            this.populateMessage()
          )}
          <img
            className="restricted__image"
            src="https://s3.amazonaws.com/prod-etr/uploads/images/etr-scope-guy.png"
          />
        </div>
      </div>
    )
  }
}

const RestrictedWithDataAndMutation = (props) => {
  return (
    <Mutation mutation={requestUpgrade}>
      {(mutate) => {
        const sendEmail = (product_id) => {
          return mutate({
            variables: { product_id: product_id },
          })
        }

        return <RestrictedWithData {...props} sendEmail={sendEmail} />
      }}
    </Mutation>
  )
}

const RestrictedWithData = (props) => {
  //RT: clean query string params
  let id = props.location.search
    ? props.location.search.replace("?id=", "")
    : null

  if (!id) {
    return <Redirect to={"/404"} />
  }

  return (
    <Query
      query={restrictedAccess}
      variables={{ id }}
      fetchPolicy="network-only"
    >
      {({ error, ...queryProps }) => {
        if (error) {
          console.log("error: ", error)
          return null
        }
        return <Restricted {...props} {...queryProps} />
      }}
    </Query>
  )
}

export default RestrictedWithDataAndMutation
